import { app } from '../../../../../app';
import { Controller } from './import-shared-authenticator.controller';

app.component('companySharingCenterSharedAuthenticatorsImport', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./import-shared-authenticator.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/import/import-shared-authenticator.component.js